import type { Comment } from '@tunasong/schemas'
import { Node } from 'slate'

/** A task's plain text, which names its checkbox (chat tasks, GH #3041) */
export const taskText = (comment: Comment) =>
  (comment.children ?? [])
    .map(node => Node.string(node as never))
    .join(' ')
    .trim()
